import { Component } from '@angular/core';
import { PlcCodes } from '@dch/products-business-logic';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent {
  title: string;
  text: string;
  plc: PlcCodes;

  destroy: Function;
  PlcCodes = PlcCodes;

  constructor(private translationService: TranslationService) {}

  close() {
    this.destroy();
  }
}
